import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { propuestasVentaApi } from '../api/propuestasVenta'
import { descargarArchivo } from '../utils/descargar'
import { fmtFecha } from '../utils/fecha'
import { colors, text, radius, sx } from '../design/tokens'
import Boton from '../components/Boton'
import Paginador from '../components/Paginador'

/**
 * VENTAS → Propuestas: piezas de oferta en PDF que los vendedores mandan a
 * sus clientes mayoristas (fotos + precios + escalas desde LGR).
 */
export default function PropuestasVentaPage() {
  const navigate = useNavigate()
  const [filas, setFilas] = useState([])
  const [paginacion, setPaginacion] = useState({ current_page: 1, last_page: 1, total: 0 })
  const [q, setQ] = useState('')
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(null)

  const cargar = (page = 1, busq = q) => {
    setCargando(true)
    propuestasVentaApi.listar({ page, q: busq || undefined })
      .then(({ data }) => {
        setFilas(data.data || [])
        setPaginacion({ current_page: data.current_page, last_page: data.last_page, total: data.total })
        setError(null)
      })
      .catch(() => setError('No se pudieron cargar las propuestas.'))
      .finally(() => setCargando(false))
  }

  useEffect(() => { cargar(1) }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const t = setTimeout(() => cargar(1, q), 350)
    return () => clearTimeout(t)
  }, [q]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: text.title, fontWeight: 600, color: colors.text }}>Propuestas de venta</h2>
        <Boton variante="primary" onClick={() => navigate('/propuestas-venta/nueva')}>+ Nueva propuesta</Boton>
      </div>

      <div style={{ marginBottom: 12 }}>
        <input
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Buscar por título..."
          style={{ padding: '6px 12px', border: `1px solid ${colors.textPlh}`, borderRadius: radius.sm, fontSize: text.body, fontFamily: 'inherit', background: colors.bg, width: 280 }}
        />
      </div>

      {error && <div style={{ color: colors.err, marginBottom: 12 }}>{error}</div>}

      <div style={{ background: colors.bg, border: `1px solid ${colors.borderSoft}`, borderRadius: radius.md, overflow: 'hidden' }}>
        {cargando && filas.length === 0 ? (
          <div style={{ padding: 24, color: colors.textSec }}>Cargando…</div>
        ) : filas.length === 0 ? (
          <div style={{ padding: 24, color: colors.textSec }}>
            Todavía no hay propuestas. Armá la primera con “+ Nueva propuesta”.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: colors.bgSoft }}>
                {['Título', 'Ítems', 'Vendedor', 'Vigencia', 'Último PDF', 'Acción'].map(h => (
                  <th key={h} style={th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filas.map(p => (
                <tr
                  key={p.id}
                  onClick={() => navigate(`/propuestas-venta/${p.id}`)}
                  onMouseEnter={e => { e.currentTarget.style.background = colors.bgSoft }}
                  onMouseLeave={e => { e.currentTarget.style.background = '' }}
                  style={{ borderBottom: `1px solid ${colors.borderSoft}`, height: 44, cursor: 'pointer' }}
                  title="Abrir la propuesta"
                >
                  <td style={{ ...td, fontWeight: 600 }}>{p.titulo}
                    {p.nota && <div style={{ fontSize: text.sec, color: colors.textMeta, fontWeight: 400 }}>{p.nota}</div>}
                  </td>
                  <td style={{ ...td, ...sx.mono, textAlign: 'center' }}>{p.items_count}</td>
                  <td style={td}>{p.vendedor?.nombre || '—'}</td>
                  <td style={{ ...td, ...sx.mono }}>
                    {p.vigencia_hasta ? `hasta ${fmtFecha(p.vigencia_hasta)}` : '—'}
                  </td>
                  <td style={{ ...td, ...sx.mono }}>{p.emitida_at ? fmtFecha(p.emitida_at) : '—'}</td>
                  <td style={td} onClick={e => e.stopPropagation()}>
                    <Boton variante="secondary" sm onClick={() => descargarArchivo(`/propuestas-venta/${p.id}/pdf`, `propuesta_${p.id}.pdf`)}>⬇ PDF</Boton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Paginador pagina={paginacion.current_page} totalPaginas={paginacion.last_page} onCambiar={(pg) => cargar(pg)} />
    </div>
  )
}

const th = {
  padding: '8px 16px', textAlign: 'left', background: colors.bgSoft,
  borderBottom: `1px solid ${colors.border}`, fontWeight: 600, fontSize: text.meta,
  color: colors.textSec, textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap',
}
const td = { padding: '6px 16px', verticalAlign: 'middle', fontSize: text.body, color: colors.text, lineHeight: 1.3 }
